
import packageJson from "../../package.json"

export const CONFIG= window.CONFIG;
export const tipoPasarela= "JPA";
export const servidor= CONFIG.servidor;

export const version= CONFIG.version;

export const servidorMailing= CONFIG.servidor;
export const servidorImagenes= CONFIG.servidorImagenes;
export const servidorDocumentos= CONFIG.servidorDocumentos;
export const sessionCaducidadMinutos= CONFIG.sessionCaducidadMinutos;
export const servidorNotificaciones= CONFIG.servidorNotificaciones;

export const servicioRestful= "restful/"
export const servicioRestfulCompleto= "completo/restful/"
export const servicioRestfulMinimo= "minimo/restful/"
export const servicioDocumental="completo/documental/"
export const nombrePaquete= "com.ej2sistemas.dental.";
export const titulo= "Clínica dental Alacuas";
export const servicioExportacion= "exportacion/";
export const servicioFicheros= "ficheros/";
export const sufijoExportacionPdf = "pdfgrid/";
export const sufijoExportacionExcel = "excelgrid/";
export const prefijoAccionesAuth= "";

export const  authModo= "BDD";
export const clinicaCodigo= CONFIG.clinicaCodigo;
export const intervaloComprobacionNotificaciones= 30; //Minutos


export const color_verde = '#b9f495';
export const color_amarillo = '#fff29e';
export const color_naranja = '#f8822c';
export const color_rojo = '#ea4343';
export const color_azul = '#0dc2d9';
export const color_azul_oscuro = '#0d8f9f';
export const color_gris = "#f9f9f9";
export const color_blanco = "#ffffff";